import GolferRow from '../components/GolferRow'
import HoleButton from '../components/HoleButton'
import { useCourseStore } from '../store/CourseStore'
import { useGolferStore } from '../store/GolferStore'
import { useRoundStore } from '../store/RoundStore'

const ScoreEntryView = ({ updateScore, disableNextButton }) => {
  const course = useCourseStore((state) => state.course)
  const groupRounds = useGolferStore((state) => state.groupRounds)
  const roundGolferMap = useGolferStore((state) => state.roundGolferMap)
  const holeNum = useRoundStore((state) => state.holeNum)
  const saveData = useRoundStore((state) => state.saveData)

  const holeData = course?.courseHoles?.find((h) => h.holeNum === holeNum)
  const isDisabled = disableNextButton()

  if (!holeData) {
    return <div>ERROR - COULD NOT RETRIEVE COURSE HOLE INFORMATION</div>
  }

  return (
    <div>
      <h2>{course.courseName}</h2>
      <div className="flex-container">
        <div className="boldNormal box3 left">#{holeNum}</div>
        <div className="boldNormal box3 center">Par {holeData?.holePar}</div>
        <div className="boldNormal box3 right">{holeData?.holeYdsB} yds</div>
      </div>
      {groupRounds?.map((round, i) => (
        <GolferRow key={i} round={round} updateScore={updateScore} index={i} golfer={roundGolferMap[round.golferId]} />
      ))}
      <table width="100%" cellPadding="4" cellSpacing="0">
        <tbody>
          <tr>
            <td align="left" id="prevHoleButtonContainer" width="50%">
              <HoleButton saveData={saveData} holeAdvance={-1} />
            </td>
            <td align="right" id="nextHoleButtonContainer" width="50%">
              <HoleButton saveData={saveData} holeAdvance={1} isDisabled={isDisabled} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ScoreEntryView
